module.exports = new __parcel__URL__("battlepass_raffle_rock.51fb1765.png").toString();